import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import quotation from 'src/repositories/quotation';
import { API_KEY } from 'src/constants/apiKey';

const usePriceFractions = () => {
  const queryFractions = useQuery<
    AxiosResponse<Response.FractionsData>,
    AxiosError<any>
  >([API_KEY.FRACTIONS], quotation.getFractions, {
    retry: 0,
    cacheTime: 0,
    onError(err) {
      console.log(err.response);
    },
  });

  return {
    queryFractions,
  };
};

export default usePriceFractions;
